import { Box, useMediaQuery, useTheme } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { PieChart } from "@mui/x-charts/PieChart";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

export default function Graphs({ type, data }: { type: string; data: any }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  function dataTable() {
    const columns: GridColDef<(typeof rows)[number]>[] = Object.keys(
      data[0]
    ).map((key: any, index) => {
      return {
        minWidth: 200,
        field: key,
        headerName: key.replace(/_/gi, " ").capitalize(),
        type:
          typeof data[0][key] === "number" && key !== "Year"
            ? "number"
            : "string",
      };
    });

    const rows = data.map((row: any, index: number) => {
      const newRow = { ...row, id: index };
      Object.keys(newRow).forEach((key) => {
        if (newRow[key] === null || newRow[key] === undefined) {
          newRow[key] = "Data Not Available";
        }
      });
      return newRow;
    });

    return (
      <Box sx={{ maxWidth: isSmallScreen ? "80vw" : "40vw" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          getRowId={(row) => row.id}
          pageSizeOptions={[5, 10, 50, 100]}
          // checkboxSelection
          // disableRowSelectionOnClick
        />
      </Box>
    );
  }

  function barchart() {
    let isGroupByYear = Object.keys(data[0]).includes("Year");

    if (isGroupByYear) {
      let groupedData = data.reduce((acc: any, x: any) => {
        acc[x["Year"]] = acc[x["Year"]] || [];
        acc[x["Year"]].push(x);

        return acc;
      }, {});

      let dataset = Object.keys(groupedData).reduce((acc: any, year) => {
        acc.push({
          year,
          ...groupedData[year].reduce((acc: any, x: any) => {
            let valueKey: any = Object.keys(x).find(
              (key) => typeof x[key] === "number" && key !== "Year"
            );

            let labelKey: any = Object.keys(x).find(
              (key) => typeof x[key] === "string" && key !== "Year"
            );

            acc[x[labelKey]] = x[valueKey];

            return acc;
          }, {}),
        });

        return acc;
      }, []);

      return (
        <BarChart
          width={isSmallScreen ? window.innerWidth / 1.5 : 600}
          height={isSmallScreen ? window.innerWidth / 1.5 : 300}
          margin={{ left: 100 }}
          dataset={dataset}
          xAxis={[{ scaleType: "band", dataKey: "year" }]}
          series={Object.keys(dataset[0] || {})
            .filter((key) => key !== "year")
            .map((key) => ({ dataKey: key, label: key }))}
        />
      );
    } else {
      let series: any = [];
      let xAxis: any = [];
      series = [
        {
          data: data.map((item: any) => {
            let valueKey = Object.keys(item).find(
              (key) => typeof item[key] === "number"
            );
            return item[valueKey!];
          }),
          type: "bar",
        },
      ];

      xAxis = [
        {
          scaleType: "band",
          data: data.map((item: any) => {
            let labelKey = Object.keys(item).find(
              (key) => typeof item[key] === "string"
            );
            return item[labelKey!];
          }),
        },
      ];

      return (
        <BarChart
          width={isSmallScreen ? window.innerWidth / 1.5 : 600}
          height={isSmallScreen ? window.innerWidth / 1.5 : 300}
          series={series}
          xAxis={xAxis}
          margin={{ left: 100 }}
        />
      );
    }
  }

  return (
    <Box mt={isSmallScreen ? 2 : 4} maxWidth={"80svw"} overflow={"scroll"}>
      {type === "bar chart" ? barchart() : null}

      {type === "pie chart" ? (
        <PieChart
          series={[
            {
              data: data.map((item: any, index: any) => {
                let valueKey = Object.keys(item).find(
                  (key) => typeof item[key] === "number"
                );
                let labelKey = Object.keys(item).find(
                  (key) => typeof item[key] === "string"
                );
                return {
                  id: index,
                  value: item[valueKey!],
                  label: item[labelKey!],
                };
              }),
            },
          ]}
          width={isSmallScreen ? window.innerWidth / 1.5 : 500}
          height={isSmallScreen ? window.innerWidth / 1.5 : 200}
        />
      ) : null}

      {type === "data table" ? dataTable() : null}
    </Box>
  );
}

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});
